import { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';
import { useTaskAttachments, useTaskComments } from '../../hooks/queries/useTaskCollaboration';
import { useTaskFiles } from '../../hooks/queries/useTaskFiles';
import { TaskAttachmentsSection } from './TaskAttachmentsSection';
import { TaskCommentsSection } from './TaskCommentsSection';
import { TaskDossierFilesSection } from '../files/TaskDossierFilesSection';
import {
  taskSecondaryAccordionLabel,
  taskSecondaryCount,
} from '../../lib/tasks/taskSecondaryAccordion';

interface TaskSecondaryAccordionProps {
  taskId: string;
  dossierId?: string | null;
}

export function TaskSecondaryAccordion({
  taskId,
  dossierId,
}: TaskSecondaryAccordionProps) {
  const [open, setOpen] = useState(false);
  const { data: attachments = [] } = useTaskAttachments(taskId);
  const { data: comments = [] } = useTaskComments(taskId);
  const { data: files = [] } = useTaskFiles(taskId);

  const count = taskSecondaryCount({
    attachments: attachments.length,
    files: files.length,
    comments: comments.length,
  });
  const label = taskSecondaryAccordionLabel(count);

  return (
    <div className="pt-2 border-t border-neutral-100">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center gap-1.5 py-1.5 text-left text-xs font-semibold uppercase tracking-wide text-cime-text-muted hover:text-cime-text-primary"
        aria-expanded={open}
      >
        {open ? (
          <ChevronDown className="h-3.5 w-3.5 shrink-0" aria-hidden />
        ) : (
          <ChevronRight className="h-3.5 w-3.5 shrink-0" aria-hidden />
        )}
        <span>{label}</span>
      </button>
      {open && (
        <div className="mt-2 space-y-4">
          <TaskAttachmentsSection taskId={taskId} />
          {dossierId && (
            <TaskDossierFilesSection taskId={taskId} dossierId={dossierId} />
          )}
          <TaskCommentsSection taskId={taskId} />
        </div>
      )}
    </div>
  );
}
